import { fetcher } from '../fetcher';
import { HttpMethod } from '../http-method';
import { UserAgent } from '../user-agent';

import { BuildEndpointOpts, DictOrVoid, FetchEndpoint, PrepareFetcher, QueryFn } from './build-endpoint.model';
import { flow, getBaseUrl, makeSearchParams } from './build-endpoint.utils';

const buildEndpoint = <EndpointResponse = any, RequestArgs extends DictOrVoid = void>({
    baseUrl = 'research-api',
    cachePrefix,
    query,
    queryFn,
    useResearchApiV2Mapper,
}: BuildEndpointOpts<EndpointResponse, RequestArgs>) => {
    const prepareFetcher: PrepareFetcher<RequestArgs> = ({
        uri,
        params,
        unencodedParams,
        options = {},
        overrideBaseUrl,
    }) => {
        const base = getBaseUrl(baseUrl, overrideBaseUrl);
        let url = `${base}${uri}`;

        const search = makeSearchParams(params, unencodedParams, baseUrl, useResearchApiV2Mapper);

        if (search) {
            url += search;
        }

        return { url, baseUrl: overrideBaseUrl ?? baseUrl, useResearchApiV2Mapper, ...options };
    };

    let fetchEndpoint: FetchEndpoint<EndpointResponse, RequestArgs>;

    if (queryFn) {
        const prepareQueryFn = (requestArgs: RequestArgs) => [requestArgs, { baseFetch: fetcher }];
        fetchEndpoint = flow(prepareQueryFn, queryFn) as FetchEndpoint<EndpointResponse, RequestArgs>;
    } else {
        fetchEndpoint = flow(
            query,
            prepareFetcher,
            fetcher,
            /** casted here so TS doesn't complain about `cachePrefix` not being assigned  */
        ) as FetchEndpoint<EndpointResponse, RequestArgs>;
    }

    fetchEndpoint.cachePrefix = cachePrefix;
    return fetchEndpoint;
};

buildEndpoint.Method = HttpMethod;
buildEndpoint.UserAgent = UserAgent;

export type { DictOrVoid, FetchEndpoint, QueryFn };
export { buildEndpoint };
